import React from "react";

function Footer() {
  return (
    <footer className="app-footer">
      <p>© Beyzanur Ayvaz | Task Calendar</p>
    </footer>
  );
}

export default Footer;
